import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { adminApi } from "@/lib/admin-api";

export const Route = createFileRoute("/admin/")({
  component: AdminIndexPage,
});

function AdminIndexPage() {
  const navigate = useNavigate();

  const { data, status, refetch } = useQuery({
    queryKey: ["admin", "dashboard"],
    queryFn: () => adminApi.getDashboard(),
  });

  if (status === "pending") {
    return (
      <div className="admin-page" data-testid="admin-index">
        <div className="admin-kpi-grid">
          <div className="admin-kpi-card admin-kpi-card--skeleton" data-testid="skeleton" />
          <div className="admin-kpi-card admin-kpi-card--skeleton" />
          <div className="admin-kpi-card admin-kpi-card--skeleton" />
          <div className="admin-kpi-card admin-kpi-card--skeleton" />
        </div>
      </div>
    );
  }

  if (status === "error" || !data) {
    return (
      <div className="admin-page" data-testid="admin-index">
        <p className="admin-kpi-error" data-testid="dashboard-error">
          Failed to load dashboard.
        </p>
        <button
          type="button"
          className="admin-kpi-retry"
          data-testid="retry-btn"
          onClick={() => void refetch()}
        >
          RETRY
        </button>
      </div>
    );
  }

  const revenue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(data.revenue_today_c / 100);

  return (
    <div className="admin-page" data-testid="admin-index">
      <div className="admin-kpi-grid">
        <button
          type="button"
          className="admin-kpi-card admin-kpi-card--clickable"
          data-testid="kpi-open-flags"
          onClick={() => void navigate({ to: "/admin/flags" })}
        >
          <span className="admin-kpi-card__label">OPEN FLAGS</span>
          <span className="admin-kpi-card__value">{data.open_flags}</span>
        </button>

        <button
          type="button"
          className="admin-kpi-card admin-kpi-card--clickable"
          data-testid="kpi-banned"
          onClick={() => void navigate({ to: "/admin/users" })}
        >
          <span className="admin-kpi-card__label">BANNED (24H)</span>
          <span className="admin-kpi-card__value">{data.banned_24h}</span>
        </button>

        <div className="admin-kpi-card" data-testid="kpi-live-automatons">
          <span className="admin-kpi-card__label">LIVE AUTOMATONS</span>
          <span className="admin-kpi-card__value">{data.live_automatons}</span>
        </div>

        <div className="admin-kpi-card" data-testid="kpi-revenue">
          <span className="admin-kpi-card__label">REVENUE TODAY</span>
          <span className="admin-kpi-card__value admin-kpi-card__value--revenue">{revenue}</span>
        </div>
      </div>
    </div>
  );
}
